// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VUPQ","rootNoMargin":"styles_rootNoMargin__ZAWd_"};